export default __webpack_public_path__ + "static/media/cardmarketLogoFull.d42233c9.svg";